export default {
  opponentRank: {
    title: "Ranking del rival",
    tabs: {
      byRanking: "Por ranking",
      allRankings: "Todos los rankings",
    },
    empty: {
      title: "No hay rankings del rival disponibles",
    },
  },
};